import { useEffect, useState } from 'react';
import { useLocalization } from '@/hooks/useLocalization';
import { useWidget } from '@/state/WidgetContext';
import { useChat } from '@/hooks/useChat';
import BotMessage from '@/components/ChatMessage/BotMessage';
import OptionButton from '@/components/OptionButton/OptionButton';
import ScreenOptions from '@/components/ScreenOptions/ScreenOptions';
import EventCard from '@/components/EventCard/EventCard';
import { eventsService } from '@/services/events';
import { SCREENS } from '@/utils/constants';
import evStyles from '@/styles/events.module.scss';

export default function EventsScreen() {
  const { t } = useLocalization();
  const { goTo } = useWidget();
  const { chooseEvent } = useChat();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    eventsService.getRecommended().then(data => {
      setEvents(data);
      setLoading(false);
    });
  }, []);

  return (
    <BotMessage text={t('results.message')}>
      <div className={evStyles.list}>
        {loading
          ? <div className={evStyles.loader}><span /><span /><span /></div>
          : events.map(ev => (
            <EventCard key={ev.id} event={ev} onClick={chooseEvent} />
          ))
        }
      </div>
      <ScreenOptions style={{ marginTop: '8px' }}>
        {/* <OptionButton variant="primary" onClick={() => goTo(SCREENS.CONTACTS)}>
          {t('results.seeAll')}
        </OptionButton> */}
        <OptionButton onClick={() => goTo(SCREENS.GUIDE)}>
          {t('results.getByEmail')}
        </OptionButton>
        <OptionButton onClick={() => goTo(SCREENS.CONTACTS)}>
          {t('results.discuss')}
        </OptionButton>
      </ScreenOptions>
    </BotMessage>
  );
}

